import React, { FunctionComponent } from "react";

import { useSearchAccessoriesByVehicle } from "../../queries/useSearchAccessoriesByVehicle";
import { StatusBar } from "../../ui/StatusBar/StatusBar";
import {
  FiltersSidebar,
  useFiltersState,
} from "../FiltersSidebar/FiltersSidebar";
import { VehicleHeader } from "../VehicleHeader/VehicleHeader";
import { AccessoryList } from "./AccessoryList";
import { AccessoryQuickFilters } from "./AccessoryQuickFilters";
import { AccessoryFilters } from "./Filters/AccessoryFilters";

export const Accessories: FunctionComponent = () => {
  const [, { hide }] = useFiltersState();
  const { data, isLoading } = useSearchAccessoriesByVehicle();

  return (
    <>
      <VehicleHeader className="mt-4 md:mt-8 mb-2">
        <StatusBar className="self-end" isLoading={isLoading}>
          <FiltersSidebar className=" self-end">
            <AccessoryFilters onClose={hide} />
          </FiltersSidebar>
          <AccessoryQuickFilters />
        </StatusBar>
      </VehicleHeader>
      <AccessoryList data={data} />
    </>
  );
};
